    import React from 'react';
    import { Modal, Button } from 'react-bootstrap';
    import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
    import { faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';

    interface ConfirmationModalProps {
      show: boolean;
      onHide: () => void;
      title: string;
      message: string;
      onConfirm: () => void;
      confirmText?: string;
      cancelText?: string;
      confirmVariant?: string;
    }

    const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
      show,
      onHide,
      title,
      message,
      onConfirm,
      confirmText = 'אשר',
      cancelText = 'ביטול',
      confirmVariant = 'danger',
    }) => {
      const handleConfirm = () => {
        onConfirm();
        onHide(); // סגור את המודאל לאחר האישור
      };

      return (
        <Modal show={show} onHide={onHide} centered>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{message}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={onHide}>
              <FontAwesomeIcon icon={faTimes} className="me-1" />
              {cancelText}
            </Button>
            <Button variant={confirmVariant} onClick={handleConfirm}>
              <FontAwesomeIcon icon={faCheck} className="me-1" />
              {confirmText}
            </Button>
          </Modal.Footer>
        </Modal>
      );
    };

    export default ConfirmationModal;
    